<template>
  <div class="inquiryBulletin">
    <div class="img-T">
      <img src="../../assets/home_img/inquiry-bulletin-banner.png" alt="" />
    </div>
    <div class="inform-main">
      <!-- tabs切换 -->
       <div>
        <div class="tabs" >
          <div class="custom-tabs" 
          v-for="item in tabsList" 
          :key="item.name" 
          :class="item.name === activeName ? 'custom-tabs-click' :''"
          @click="activeClick(item.name)"
          >
            <div class="custom-tabs-label">
              <img :src="item.img" alt=""  />
              <span>{{item.tabName}}</span>
            </div>
            <div class="line"></div>
          </div>
        </div>
       </div>
      <div class="I-item">
        <el-input
          v-model="config.purchaseName"
          placeholder="请输入公司名称"
          style="width: 600px"
          class="mr-15"
        ></el-input>
        <el-input
          v-model="config.goodsName"
          placeholder="请输入商品名称"
          class="mr-15"
          style="width: 300px"
        ></el-input>
        <el-select
          v-model="config.billStatus"
          placeholder="请选择信息状态"
          class="mr-15"
          clearable
        >
          <el-option
            v-for="item in billStatusOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="searchFor()">搜索</el-button>
        <el-button type="primary" @click="resetting()">重置</el-button>
      </div>

      <div class="data-list" v-loading="loading">
        <div class="nodataImg" v-if="comingSoon">
          <img src="../../assets/img/inquiryBulletin/default.png" alt="">
        </div>
        <div class="data-list-box" v-else>
          <div class="nodataImg" v-if="list.length == 0">
          <img src="../../assets/zxx_img/nodata.png" alt="" />
        </div>
        <template v-else>
        <div
          class="list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="todetail(item)"
        >
          <div class="title">
            <div class="title-left">
              <div v-if="item.groupName">
                <span class="tag-jt">集团</span>{{ item.groupName }}
              </div>
              <div><span class="tag-dw">单位</span>{{ item.purchaseName }}</div>
            </div>
            <div
              class="title-right"
              :style="{
                color:
                  item.billStatusLabel == '进行中'
                    ? '#4DC727'
                    : item.billStatusLabel == '未开始'
                    ? '#FF0000'
                    : '#FF8F12',
              }"
            >
              {{ item.billStatusLabel }}
            </div>
          </div>
          <div class="content">
            <div>{{ item.goodsName }}</div>
            <div class="flex">
              <div>{{ item.goodsQty }}吨</div>
              <div class="a-r">截止报名时间:{{ item.expireEndTime }}</div>
            </div>
            <div class="quality f-hide2">
              质量要求:
              <span :title="computedQuotas(item.inquiryBulletinQuotaList)">
                {{ computedQuotas(item.inquiryBulletinQuotaList) }}</span
              >
            </div>
            <div class="remark">
              备注：
              <span :title="item.remark"> {{ item.remark }}</span>
            </div>
            <div class="location">
              <i class="hy-icon-dizhi"></i>

              <span :title="item.deliveryLocation">
                {{ item.deliveryLocation }}</span
              >
            </div>
          </div>
        </div>
        </template>
        </div>
        <!-- 分页 -->
        <el-row
          type="flex"
          justify="end"
          style="height: 50px; width: 100%"
          align="middle"
          v-if="!comingSoon"
        >
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="total"
            :current-page="config.pageNum"
            :page-size="config.pageSize"
            @current-change="changePage"
          />
        </el-row>
      </div>
    </div>
    <DetailDialog ref="detailDialog"></DetailDialog>
  </div>
</template>

<script>
import { getinquiryBulletinPage } from "@/api/home";
import DetailDialog from "./components/detail";
import group1Img from '@/assets/img/inquiryBulletin/group1.png'
import group2Img from '@/assets/img/inquiryBulletin/group2.png'
import group3Img from '@/assets/img/inquiryBulletin/group3.png'

const { baseUrl } = require("@/config");

export default {
  components: {
    DetailDialog,
  },
  data() {
    return {
      /** 当前选中的tab */
      activeName:'',
      /** tab 列表 */
      tabsList:[
        {tabName: '华润集团采购招标公示专区', name:'华润集团',img:group2Img},
        {tabName: '华电集团采购招标公示专区', name:'华电集团',img:group1Img},
        {tabName: '华能集团采购招标公示专区', name:'华能集团',img:group3Img},
      ],
      /** 华能集团'敬请期待'状态 */
      comingSoon: false,
      /** 列表加载状态 */
      loading:'false',
      total: 0,
      list: [],
      billStatusOption: [
        {
          label: "未开始",
          value: "1",
        },
        {
          label: "进行中",
          value: "2",
        },
        {
          label: "已结束",
          value: "3",
        },
      ],
      purchaseOptions: [],

      config: {
        purchaseName: "",
        billStatus: "",
        goodsName: "",
        pageNum: 1,
        pageSize: 9,
      },
      dialogData: {
        imgUrl: "",
        title: "",
        centerDialogVisible: false,
        bulletinLink: "",
      },
      baseUrl: baseUrl,
      checked: false,
    };
  },
  created() {
    this.activeClick("华润集团")
  },
  computed: {
    computedQuotas() {
      return (val) => {
        let quotaValue = "";
        (val || []).forEach((qitem) => {
          if(!(qitem.quotaValue === '' || qitem.quotaValue === null || qitem.quotaValue === undefined)){
            quotaValue += qitem.quotaName + qitem.quotaValue + ";";
          }
        });
        quotaValue = quotaValue.slice(0, -1);
        return quotaValue;
      };
    },
  },
  methods: {
    changePage(newPage) {
      this.config.pageNum = newPage;
      this.getInquiryBulletinList();
    },
    /** tabs点击切换 */
    activeClick(name){
      this.loading = true
      this.activeName = name
      /** 如果是华能集团 直接显示'敬请期待' */
      if(name === '华能集团'){
        this.comingSoon = true
        this.loading = false
      }else{
        this.comingSoon = false
        this.searchFor()
        this.loading = false
      }
    },
    // 每页显示信息条数
    handleSizeChange(val) {
      this.config.size = val;
      this.getInquiryBulletinList();
    },
    searchFor() {
      this.config.pageNum = 1;
      this.config.groupName = this.activeName
      this.getInquiryBulletinList();
    },
    resetting() {
      this.config = {
        pageNum: 1,
        pageSize: 9,
        purchaseName: "",
        billStatus: "",
        goodsName: "",
      };
      this.getInquiryBulletinList();
    },
    todetail(row) {
      this.$refs.detailDialog.openDialog(row);
    },
    updateVisible() {
      this.dialogData.centerDialogVisible = false;
    },
    getInquiryBulletinList() {
      getinquiryBulletinPage(this.config).then((res) => {
        console.log("BulletinPage", res);
        if (res.code == 0) {
          this.total = res.data.total;
          this.list = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
  position: relative;
  .title {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    line-height: 30px;
  }
  .go_0 {
    position: absolute;
    top: 0px;
    left: 10px;
    text-align: center;
    line-height: 30px;
    width: 90px;
    height: 34px;
    border: 1px solid #d2d2d2;
    border-radius: 17px;
    font-size: 14px;
    cursor: pointer;
  }
}
.dialog_center {
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;

  .data {
    text-align: center;
    padding: 10px;
    background: #f3f3f7;
  }
}
.inquiryBulletin {
  .mr-15 {
    margin-right: 15px;
  }
  .a-r {
    text-align: right;
  }
  .inform-main {
    width: 1455px;
    margin: 20px auto 100px;
    .I-item {
      display: flex;
      padding: 15px;
      background: #fff;
    }
    .tabs {
      display: flex;
      margin-bottom: 20px;
      .custom-tabs {
        position: relative;
        width: 354px;
        height: 68px;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px 0px rgba(204,205,214,0.25);
        border-radius: 2px 2px 2px 2px;
        margin-right: 16px;
        cursor: pointer;
        .custom-tabs-label {
          font-weight: 600;
          font-size: 18px;
          margin-top: 8px;
          img {
            width: 58px;
            height: 58px;
            margin: 0 8px 0 28px;
            vertical-align: middle;
            transform: translateY(-2px);
          }
        }
      }
      .custom-tabs-click {
        .line{
          position: absolute;
          bottom: 0;
          width: 354px;
          height: 2px;
          background: #4861FE;
          border-radius: 2px 2px 2px 2px;
        }
      }
    }
  }
  .data-list {
    background-color: #fff;
    margin-top: 20px;
    padding: 36px 36px 36px;
    .data-list-box{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 30px;
    }
    .nodataImg {
      padding: 200px 0;
      text-align: center;
      width: 1455px;
    }
    .list-item {
      width: 441px;
      height: 270px;
      background: #ffffff;
      box-shadow: 0px 4px 16px 7px rgba(74, 90, 217, 0.1);
      border-radius: 10px 10px 10px 10px;
      padding: 0px 20px;
      cursor: pointer;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #d8d8d8;
        padding: 20px 0px 10px 0px;
        font-weight: bold;
        height: 75px;
        .title-left {
          div {
            margin-top: 5px;
            vertical-align: middle;
          }
          .tag-jt {
            background: linear-gradient(270deg, #217afb 0%, #4aaffc 100%),
              #d8d8d8;
            border-radius: 2px 2px 2px 2px;
            padding: 2px 5px;
            color: #fff;
            margin-right: 8px;
          }
          .tag-dw {
            background: linear-gradient(180deg, #ff8430 0%, #ffb586 100%);
            border-radius: 2px 2px 2px 2px;
            padding: 2px 5px;
            color: #fff;
            margin-right: 8px;
          }
        }
        .title-right {
          width: 100px;
          text-align: right;
        }
      }
      .content {
        padding: 10px;
        line-height: 22px;
        .flex {
          display: flex;
          justify-content: space-between;
        }
        .quality {
          margin-top: 8px;
          height: 44px;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;     /* 垂直排列 */
        }
        .remark {
          margin-top: 8px;
          padding: 0px 10px;
          border-radius: 2px 2px 2px 2px;
          background-color: #f3f3f7;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 30px;
          height: 30px;
          white-space: nowrap;
        }
        .location {
          padding-top: 10px;
          overflow: hidden;
          text-overflow: ellipsis;

          white-space: nowrap;
          height: 30px;
        }
      }
    }
  }
}

.img-T {
  min-width: 1903px;
  margin-top: 0px;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
